<template>
  <v-container fluid fill-height class="start-view py-0">

    <v-progress-linear style="position: fixed; left: 0; right: 0; margin: 0; z-index: 99;"
                       :style="{top: $vuetify.breakpoint.smAndDown ? '54px' : '62px'}" color="primary lighten-2"
                       height="2" v-show="subtleLoading" :indeterminate="true"></v-progress-linear>

    <hb-loading-indicator v-if="loading" align-middle/>

    <v-fade-transition>
      <v-row v-if="!loading" style="position: relative;" :class="$vuetify.breakpoint.smAndDown ? 'fill-height' : ''">
        <v-col cols="12" md="8" offset-md="2" xl="6" offset-xl="3" :class="$vuetify.breakpoint.smAndDown ? 'fill-height' : ''">
          <v-card color="secondary" :class="$vuetify.breakpoint.smAndDown ? 'fill-height' : ''">
            <v-container fill-height pa-6>
              <v-row>
                <v-col cols="12" class="py-16">
                  <div style="position: relative;">
                  <v-img :src="$assetImageUrl + 'img/face-2.svg'" :width="$vuetify.breakpoint.smAndDown ? 65 : $vuetify.breakpoint.xl ? 150 : 90" class="face"/>
                  <div class="headline mb-5">{{ $t('online_test.work_for_us') }}</div>
                  <div class="title mb-5 introduction">{{ $t('online_test.work_for_us_introduction') }}</div>
                  <v-btn color="primary" :block="$vuetify.breakpoint.smAndDown" class="accent-2--text" @click="forwardInTest">{{ $t('online_test.start') }}</v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-fade-transition>

  </v-container>
</template>

<script>

  export default {
    name: "StartView",
    components: {
    },
    data() {
      return {
        loading: true,
        subtleLoading: false,
      }
    },
    methods: {
      forwardInTest() {
        this.$router.push({name: 'online_test'});
      },
    },
    mounted() {
      this.loading = false;
    },
  }
</script>

<style lang="scss" scoped>
  .face {
    position: absolute;
    top: -60px;
    right: 20px;
  }

  @media only screen and (min-width: 960px) {
    .introduction {
      padding-right: 100px;
    }
  }

  @media only screen and (min-width: 1200px) {
    .introduction {
      padding-right: 200px;
    }
    .face {
      top: -30px;
      right: 60px;
    }
  }
</style>
